export const allowIronTTBData: any = {
  'P790-21': {
    name: 'P790 IRONS',
    nameMacroCode: 'TA228',
  },
  'P770-23': {
    name: 'P770 IRONS',
    nameMacroCode: 'TA240',
  },
  'P7MC-23': {
    name: 'P7MC IRONS',
    nameMacroCode: 'TA239',
  },
  'P7MB-23': {
    name: 'P7MB IRONS',
    nameMacroCode: 'TA238',
  },
  P7TW: {
    name: 'P7TW IRONS',
    nameMacroCode: 'AL447',
  },
  Stealth: {
    name: 'STEALTH IRONS',
    nameMacroCode: 'TA203',
  },
  'Stealth HD Iron': {
    name: 'STEALTH HD IRONS',
    nameMacroCode: 'TC502',
  },
  'P790-21 UDI': {
    name: 'P790 UDI',
    nameMacroCode: 'TA217',
  },
  'Stealth UDI': {
    name: 'Stealth UDI',
    nameMacroCode: 'TA237',
  },
  'Stealth DHY': {
    name: 'STEALTH DHY',
    nameMacroCode: 'TA235',
  },
};

export const getSKUForProduct = (clubModel?: string, clubType?: string): string => {
  let sku = '';
  if (clubModel === 'BRNR Mini Dr' || clubModel === 'BRNR Mini Driver') {
    sku = 'TA111';
  }
  if (clubModel === 'Stealth 2 Dr' || clubModel === 'Stealth 2 Driver') {
    sku = 'TA105';
  }
  if (clubModel === 'Stealth 2 Plus Dr' || clubModel === 'Stealth 2 Plus Driver') {
    sku = 'TA101';
  }
  if (clubModel === 'Stealth 2 HD Dr' || clubModel === 'Stealth 2 HD Driver') {
    sku = 'TA108';
  }
  if (clubModel === 'Stealth 2 HD Womens Dr' || clubModel === 'Stealth 2 HD Womens Driver') {
    sku = 'TA109';
  }
  if (clubModel === 'Stealth 2 Plus Fairway') {
    sku = 'TA103';
  }
  if (clubModel === 'Stealth 2 Fairway') {
    sku = 'TA115';
  }
  if (clubModel === 'Stealth 2 HD Fairway') {
    sku = 'TA117';
  }
  if (clubModel === 'Stealth 2 HD Womens Fairway') {
    sku = 'TA118';
  }
  if (clubModel === 'Kalea Premier') {
    sku = 'TA057';
  }
  if (clubModel === 'Kalea Premier Fwy') {
    sku = 'TA085';
  }

  if (clubType === 'TM_IRONS_MODEL' || clubType === 'Iron') {
    Object.keys(allowIronTTBData).forEach(key => {
      if (allowIronTTBData[key]?.name === clubModel) {
        sku = allowIronTTBData[key].nameMacroCode;
      }
    });
  }

  return sku;
};
